import SiteHeader from "containers/SiteHeader";
import { useHotels } from "contexts/HotelsSearchContext/HotelProvider";
import React, { ReactNode, useEffect } from "react";
import Footer from "shared/Footer/Footer";

interface NoSearchEngineTemplateProps {
  children: ReactNode;
}

export const NoSearchEngineTemplate: React.FC<NoSearchEngineTemplateProps> = ({
  children,
}) => {
  const { setSearchEngine } = useHotels();

  useEffect(() => {
    setSearchEngine(false);
  }, [setSearchEngine]);

  return (
    <>
      <SiteHeader />
      {children}
      <Footer />
    </>
  );
};
